module.exports = __webpack_public_path__ + "img/home-photo.1b032190.jpg";